import { Hompage } from "./components/Hompage";
function App() {
  return (
    <Hompage />
  );
}

export default App;
